import React, { useState } from "react";
import { Modal, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import EditPlotModalContent from "./EditPlotModalContent";

const PlotIconGroup = ({
  plotLabel,
  plot,
  updateCallback,
  deleteCallback,
  allOrgs,
  allSites,
  allCrops,
  allVarieties,
}) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const handleEditCancel = () => {
    setEditModalOpen(false);
  };

  const handleDelete = () => {
    deleteCallback(plot.id);
  };

  return (
    <div className="flex items-center">
      {/* Edit Icon */}
      <EditOutlined
        className="pr-2 cursor-pointer text-primaryBlue"
        onClick={() => setEditModalOpen(true)}
      />

      {/* Delete Icon with Confirmation */}
      <Popconfirm
        title={"Are you sure you want to delete this " + plotLabel + "?"}
        onConfirm={handleDelete}
        okText="Yes"
        cancelText="No"
        placement="topRight"
      >
        <DeleteOutlined className="cursor-pointer text-dangerRed" />
      </Popconfirm>

      {/* Edit Plot Modal */}
      <Modal
        maskClosable={false}
        title={
          <div className="mb-5 font-IBMPlexSansBold text-2xl">Edit {plotLabel}</div>
        }
        open={editModalOpen}
        onCancel={handleEditCancel}
        footer={null}
      >
        <EditPlotModalContent
            plotLabel={plotLabel}
          setOpen={setEditModalOpen}
          data={plot}
          updateCallback={updateCallback}
          allOrgs={allOrgs}
          allSites={allSites}
          allCrops={allCrops}
          allVarieties={allVarieties}
        />
      </Modal>
    </div>
  );
};

export default PlotIconGroup;
